// Rukasa Hero Slider (rhs) — standalone, no dependency on Dawn's slider JS
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.rhs').forEach(function (root) {
    var slides = root.querySelectorAll('.rhs__slide');
    var dots = root.querySelectorAll('.rhs__dot');
    var prevBtn = root.querySelector('.rhs__nav--prev');
    var nextBtn = root.querySelector('.rhs__nav--next');
    if (slides.length < 2) return;

    var duration = (parseFloat(root.getAttribute('data-speed')) || 5) * 1000;
    root.style.setProperty('--rhs-duration', duration + 'ms');

    var current = 0;
    var timer = null;

    function updateDots() {
      dots.forEach(function (dot, i) {
        dot.classList.remove('rhs__dot--active', 'rhs__dot--done');
        if (i < current) dot.classList.add('rhs__dot--done');
        if (i === current) dot.classList.add('rhs__dot--active');
      });
    }

    function goTo(index) {
      slides[current].classList.remove('rhs__slide--active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('rhs__slide--active');
      updateDots();
      restart();
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function restart() {
      clearTimeout(timer);
      timer = setTimeout(next, duration);
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); });
    });
    if (nextBtn) nextBtn.addEventListener('click', next);
    if (prevBtn) prevBtn.addEventListener('click', prev);

    updateDots();
    restart();
  });
});
